import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-key-features-of-trinka',
  templateUrl: './key-features-of-trinka.component.html',
  styleUrls: ['./key-features-of-trinka.component.scss']
})
export class KeyFeaturesOfTrinkaComponent {

  @Input() title: string = 'Trinka 主要特色';

  keyFeatures = [
    { title: '文法檢查', route: ['/features/grammar-checker'], icon: '/assets/images/menu-icons/grammar-checker.svg', alt: 'Grammar checker tool icon' },
    { title: '文章改寫', route: ['/features/paraphraser'], icon: '/assets/images/menu-icons/pharaphraser.svg', alt: 'Paraphraser tool icon' },
    { title: 'AI Studio', route: ['/features/ai-studio/ai-writing-tools'], icon: '/assets/images/menu-icons/ai-studio.svg', alt: 'Apps library icon' },    
    { title: '一致性檢查', route: ['/features/consistency-check'], icon: '/assets/images/menu-icons/consistency.svg', alt: 'consistency checker' },
    { title: '自動文件編輯', route: ['/features/proofread-file'], icon: '/assets/images/menu-icons/proofread.svg', alt: 'proofreading file' },
    { title: 'LaTeX 文件校對', route: ['/features/latex-grammar-checker'], icon: '/assets/images/menu-icons/spell-check.svg', alt: 'latex Proofreader' },
    { title: '中性語言檢查', route: ['/features/inclusive-language-check'], icon: '/assets/images/menu-icons/inclusive-language.svg', alt: 'bias free writing' },
    { title: '個人詞典', route: ['/features/personal-dictionary'], icon: '/assets/images/menu-icons/personal-dictionary.svg', alt: 'dictionary' },
    { title: '抄襲檢測', route: ['/features/plagiarism-check'], icon: '/assets/images/menu-icons/plagiarism.svg', alt: 'plagiarism-check' },
    { title: '引文檢查器', route: ['/features/citation-checker'], icon: '/assets/images/menu-icons/citation-checker.svg', alt: 'check for correct references' },
    { title: '引文格式整理器', route: ['/features/citation-formatter'], icon: '/assets/images/menu-icons/citation-formatter.svg', alt: 'citation formatter' },
    { title: '期刊查找', route: ['/features/journal-finder'], icon: '/assets/images/menu-icons/journal-finder.svg', alt: 'find right journal' },
  ];

  trackByFn(index: number, item: any): string | number {
    return item.id || index;
  }
}
